import { LocationItem, SimpleItem } from 'components/location/interfaces'
import * as Yup from 'yup'

export const getValidationSchema = isNewAddress =>
  Yup.object({
    locationUsageName: Yup.string().nonNullable().required('This field is required.'),
    locationUsageCode: Yup.string().nonNullable().required('This field is required.'),
    legalEntity: Yup.object()
      .shape({
        label: Yup.string().required('This field is required.'),
        value: Yup.string().required('This field is required.')
      })
      .required('This field is required.'),
    locationStatus: Yup.object()
      .shape({
        label: Yup.string().required('This field is required.'),
        value: Yup.string().required('This field is required.')
      })
      .required('This field is required.'),
    locationType: Yup.object()
      .shape({
        label: Yup.string().required('This field is required.'),
        value: Yup.string().required('This field is required.')
      })
      .required('This field is required.'),
    locationSubtype: Yup.object()
      .shape({
        label: Yup.string().required('This field is required.'),
        value: Yup.string().required('This field is required.')
      })
      .required('This field is required.'),
    locationRegions: Yup.array(),
    externalIdList: Yup.array().of(
      Yup.object().shape({
        id: Yup.number(),
        value: Yup.string()
      })
    ),
    county: Yup.object().shape({
      id: Yup.string().when(isNewAddress, (_, schema) =>
        isNewAddress === 'false' ? schema.nullable() : schema.required()
      ),
      name: Yup.string().when(isNewAddress, (_, schema) =>
        isNewAddress === 'false' ? schema.nullable() : schema.required()
      )
    }),
    city: Yup.object().shape({
      id: Yup.string().when(isNewAddress, (_, schema) =>
        isNewAddress === 'false' ? schema.nullable() : schema.required()
      ),
      name: Yup.string().when(isNewAddress, (_, schema) =>
        isNewAddress === 'false' ? schema.nullable() : schema.required()
      )
    }),
    streetName: Yup.string().when(isNewAddress, (_, schema) =>
      isNewAddress === 'false'
        ? schema.nullable()
        : schema.nonNullable().required('This field is required.')
    ),
    streetNumber: Yup.string().when(isNewAddress, (_, schema) =>
      isNewAddress === 'false'
        ? schema.nullable()
        : schema.nonNullable().required('This field is required.')
    ),
    entrance: Yup.string(),
    floor: Yup.string(),
    apartmentNumber: Yup.string(),
    postalCode: Yup.string(),
    coordinatesX: Yup.string(),
    coordinatesY: Yup.string(),
    locationAddress: Yup.object()
      .shape({
        id: Yup.string().when(isNewAddress, (_, schema) =>
          isNewAddress === 'true' ? schema.nullable() : schema.required('This field is required.')
        ),
        name: Yup.string(),
        completeAddress: Yup.string()
      })
      .when(isNewAddress, (_, schema) =>
        isNewAddress === 'true' ? schema.nullable() : schema.required()
      )
  })

export const getInitialValues = (editItem: LocationItem, locationSystems: SimpleItem[]) => ({
  locationUsageName: editItem?.name ?? '',
  locationUsageCode: editItem?.code ?? '',
  legalEntity: editItem?.legalEntity
    ? { value: editItem.legalEntity.id, label: editItem.legalEntity.name }
    : null,
  locationStatus: editItem?.locationStatus
    ? { value: editItem.locationStatus.id, label: editItem.locationStatus.name }
    : null,
  locationType: editItem?.subtype
    ? { value: editItem.subtype.type.id, label: editItem.subtype.type.name }
    : null,
  locationSubtype: editItem?.subtype
    ? { value: editItem.subtype.id, label: editItem.subtype.name }
    : null,
  locationRegions:
    editItem?.regionList?.map(item => ({
      value: item.region.id,
      label: `${item.region.category.name} - ${item.region.name}`
    })) ?? [],
  externalIdList:
    locationSystems?.map(system => ({
      ...system,
      value: editItem?.externalIdList
        ? editItem.externalIdList.find(item => item.system.id === system.id)?.value
        : ''
    })) ?? [],
  county: editItem
    ? {
        id: editItem.locationUsageAddress.address.city.county.id,
        name: editItem.locationUsageAddress.address.city.county.name
      }
    : { id: '', name: '' },
  city: editItem
    ? {
        id: editItem.locationUsageAddress.address.city.id,
        name: editItem.locationUsageAddress.address.city.name
      }
    : { id: '', name: '' },
  apartmentNumber: editItem?.locationUsageAddress.address?.apartmentNumber ?? '',
  streetName: editItem?.locationUsageAddress.address?.streetName ?? '',
  streetNumber: editItem?.locationUsageAddress.address?.streetNumber ?? '',
  entrance: editItem?.locationUsageAddress.address?.entrance ?? '',
  floor: editItem?.locationUsageAddress.address?.floor ?? '',
  postalCode: editItem?.locationUsageAddress.address?.postalCode ?? '',
  coordinatesX: editItem?.locationUsageAddress.geolocation?.coordinatesX ?? '',
  coordinatesY: editItem?.locationUsageAddress.geolocation?.coordinatesY ?? '',
  locationAddress: { name: '', id: '', completeAddress: '' }
})
